import type { Middleware } from "@reduxjs/toolkit";

import { stampSiteTenantId, updateSite } from "~/store/siteSlice";

// Stamps the selected site with the current tenantId so no dispatch(updateSite(...)) call site needs to pass it itself.
const siteTenantStampMiddleware: Middleware = (api) => (next) => (action) => {
	const result = next(action);
	if (updateSite.match(action) && action.payload) {
		const tenantId = (api.getState() as { settings?: { tenantId?: string } }).settings?.tenantId;
		if (tenantId) api.dispatch(stampSiteTenantId(tenantId));
	}
	return result;
};

export default siteTenantStampMiddleware;
